import { useEffect } from "react";

/**
 * Inyecta fuente Outfit y estilos globales (scrollbar, animaciones, etc.)
 */
export default function GlobalStyle() {
  useEffect(() => {
    const link = document.createElement("link");
    link.href = "https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800;900&display=swap";
    link.rel = "stylesheet";
    document.head.appendChild(link);

    const style = document.createElement("style");
    style.textContent = `
      * { box-sizing: border-box; }
      body { margin: 0; background: #F4F4F6; }
      input[type=number]::-webkit-inner-spin-button,
      input[type=number]::-webkit-outer-spin-button { -webkit-appearance: none; margin: 0; }
      input[type=number] { -moz-appearance: textfield; }
      ::-webkit-scrollbar { width: 4px; height: 4px; }
      ::-webkit-scrollbar-track { background: transparent; }
      ::-webkit-scrollbar-thumb { background: rgba(0,0,0,0.10); border-radius: 99px; }
      select option { background: white; color: #1A1A2E; }
      @keyframes dukyBounce { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-4px)} }
      @keyframes fadeSlideUp { from{opacity:0;transform:translateY(10px)} to{opacity:1;transform:translateY(0)} }
      @keyframes sheetUp { from{transform:translateY(100%)} to{transform:translateY(0)} }
      @keyframes pulse { 0%,100%{opacity:0.4} 50%{opacity:1} }
      .duky-bounce { animation: dukyBounce 2s ease-in-out infinite; }
      .fade-slide-up { animation: fadeSlideUp 0.3s ease forwards; }
    `;
    document.head.appendChild(style);
  }, []);

  return null;
}
